import { DefaultEffects, IButtonStyles, IStyleFunctionOrObject, ITextFieldStyleProps, ITextFieldStyles, mergeStyles } from "@fluentui/react";


export const popupContainerStyles = mergeStyles([{
    background: 'rgba(0, 0, 0, 0.57)',
    bottom: '0',
    left: '0',
    position: 'fixed',
    right: '0',
    top: '0',
}]);

export const popupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '30rem',
    height: '20rem',
    minWidth: '30rem',
    minHeight: '20rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const xxlPopupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '28rem',
    height: '18rem',
    minWidth: '28rem',
    minHeight: '18rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const xlPopupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '26rem',
    height: '19rem',
    minWidth: '26rem',
    minHeight: '19rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const lgPopupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '28rem',
    height: '18rem',
    minWidth: '28rem',
    minHeight: '18rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const mdPopupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '28rem',
    height: '16rem',
    minWidth: '28rem',
    minHeight: '16rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const smPopupContentStyles = mergeStyles([{
    background: 'white',
    border: '1px solid black',
    boxShadow: DefaultEffects.elevation64,
    borderRadius: DefaultEffects.roundedCorner6,
    left: '50%',
    width: '95dvw',
    height: '18rem',
    minWidth: '18rem',
    minHeight: '18rem',
    padding: '0 2dvh 2dvh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
}]);

export const titleContainerStyles = mergeStyles([{
    width: '100%',
    height: '70%'
}]);

export const contentContainerStyles = mergeStyles([{
    width: '100%',
    height: '30%'
}]);

export const textFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: '1.5rem',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '4rem',
        height: '4rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    }
}

export const xxlTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '3.8rem',
        height: '3.8rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    }
}

export const xlTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: 'clamp(1rem, 2vw, 2rem)',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '3.5rem',
        height: '3.5rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    }
}

export const lgTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: 'clamp(1rem, 2vw, 2rem)',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '3.6rem',
        height: '3.6rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    }
}

export const mdTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: 'clamp(1rem, 2vw, 2rem)',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '3.7rem',
        height: '3.7rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    }
}

export const smTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '4px',
    },
    field: {
        boxShadow: DefaultEffects.elevation8,
        fontFamily: 'Nunito',
        textAlign: 'center',
        fontSize: 'clamp(1rem, 2vw, 2rem)',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '4px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: 'clamp(2.8rem, 4vw, 4rem)',
        height: 'clamp(2.8rem, 4vw, 4rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '4px'
    },
    wrapper: {
        borderRadius: '4px'
    }
}

export const successButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2vw, 1.2rem)',
        height: '2.5rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const xxlSuccessButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.7rem, 1.6vw, 1.1rem)',
        height: '2.3rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const xlSuccessButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 1.8vw, 1.1rem)',
        height: '2.2rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const lgSuccessButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.4vw, 2rem)',
        height: '2.4rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const mdSuccessButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
        height: '2.5rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const smSuccessButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 3vw, 1.8rem)',
        height: '2.2rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};


export const dismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2vw, 1.2rem)',
        height: '2.5rem',
        fontWeight: 600,
        color: '#323130',
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const xxlDismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.7rem, 1.6vw, 1.1rem)',
        height: '2.3rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const xlDismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 1.8vw, 1.1rem)',
        height: '2.2rem',
        fontWeight: 600,
        color: '#323130',
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const lgDismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.4vw, 2rem)',
        height: '2.4rem',
        fontWeight: 600,
        color: '#323130',
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const mdDismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
        height: '2.5rem',
        fontWeight: 600,
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

export const smDismissButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 3vw, 1.8rem)',
        height: '2.2rem',
        fontWeight: 600,
        color: '#323130',
        boxShadow: DefaultEffects.elevation8,
        borderRadius: DefaultEffects.roundedCorner4,
    }
};

//Switch

export const switchButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.7rem, 2vw, 1rem)',
        fontWeight: 500,
        color: '#323130',
        borderRadius: DefaultEffects.roundedCorner4,
    }
};


export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 2.5vw, 1.4rem)',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.3rem, 2.5vw, 1.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const subTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: '1dvh',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xxlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.3vw, 1rem)',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: 'clamp(0.8rem, 2.3vw, 1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.2vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: 'clamp(0.7rem, 2.2vw, 0.9rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const lgSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1.1rem)',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: 'clamp(0.8rem, 2vw, 1.1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const mdSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 1.9vw, 1rem)',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: 'clamp(0.7rem, 1.9vw, 1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const smSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    fontWeight: 300,
    color: '#323130',
    paddingBottom: '4dvh',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const errorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: 'red',
    paddingBottom: '1dvh',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xxlErrorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.3vw, 1rem)',
    fontWeight: 300,
    color: 'red',
    paddingBottom: 'clamp(0.8rem, 2.3vw, 1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const xlErrorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.2vw, 0.9rem)',
    fontWeight: 300,
    color: 'red',
    paddingBottom: 'clamp(0.7rem, 2.2vw, 0.9rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const lgErrorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1.1rem)',
    fontWeight: 300,
    color: 'red',
    paddingBottom: 'clamp(0.8rem, 2vw, 1.1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const mdErrorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 1.9vw, 1rem)',
    fontWeight: 300,
    color: 'red',
    paddingBottom: 'clamp(0.7rem, 1.9vw, 1rem)',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);

export const smErrorStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    fontWeight: 300,
    color: 'red',
    paddingBottom: '4dvh',
    paddingTop: '1dvh',

    textAlign: 'left'
}]);